module.exports = {
  path: '//payment',
  payment: {
    path: '/',
    post: true
  },
  status: {
    path: '/:id/status',
    put: true
  }
};
